import referrerFriendBR from './referrerFriend.br';

const locales = {
  BR: referrerFriendBR,
};

export default locales;
